import { render, staticRenderFns } from "./PatientRoom.vue?vue&type=template&id=65829862&scoped=true"
import script from "./PatientRoom.vue?vue&type=script&lang=js"
export * from "./PatientRoom.vue?vue&type=script&lang=js"
import style0 from "./PatientRoom.vue?vue&type=style&index=0&id=65829862&prod&scoped=true&lang=css"
import style1 from "./PatientRoom.vue?vue&type=style&index=1&id=65829862&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65829862",
  null
  
)

export default component.exports